import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";

import { LossType } from "@api/operations.generated";

import { TheftOrVandalismForm } from "@routing/routes/EnterClaimDetails/TheftOrVandalism/form";
import { WeatherOrPropertyDamageForm } from "@routing/routes/EnterClaimDetails/WeatherOrPropertyDamage/form";
import { WaterDamageSourceForm } from "@routing/routes/EnterClaimDetails/WaterDamage/form";
import { FireOrSmokeDamageForm } from "@routing/routes/EnterClaimDetails/FireOrSmokeDamage/form";
import { LiabilityForm } from "@routing/routes/EnterClaimDetails/Liability/form";
import { OtherForm } from "@routing/routes/EnterClaimDetails/Other/form";

export type ClaimDetailsForm =
  | FireOrSmokeDamageForm
  | TheftOrVandalismForm
  | LiabilityForm
  | OtherForm
  | WeatherOrPropertyDamageForm
  | WaterDamageSourceForm;

export interface ClaimDetails {
  type: LossType;
  value: ClaimDetailsForm;
}

const initialState: ClaimDetails = {
  type: undefined,
  value: undefined,
};

const claimDetailsSlice = createSlice({
  name: "claimDetails",
  initialState,
  selectors: {
    selectClaimDetails: (state) => state.value,
    selectClaimDetailsType: (state) => state.type,
  },
  reducers: {
    submitClaimDetails: (state, { payload }: PayloadAction<ClaimDetails>) => {
      state.type = payload.type;
      state.value = cloneDeep(payload.value);
    },
    resetClaimDetails: () => initialState,
  },
});

export const {
  actions: { submitClaimDetails, resetClaimDetails },
  selectors: { selectClaimDetails, selectClaimDetailsType },
} = claimDetailsSlice;
export { initialState as claimDetailsInitialState };
export default claimDetailsSlice;
